import React, {useState} from "react";
import {useNavigate, useParams} from "react-router-dom";
import {Form} from "react-bootstrap";
import {ErrorToast, SuccessToast} from "../../../shared/toasters/toasters";
import {useTranslation} from "react-i18next";
import {CreateForm, NewsItem} from "./CreateForm";
import {AdminTestsService} from "../service";
import "../../../assets/scss/scroll.scss";

export const UpdateTests = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [disabledSubmit, setDisabledSubmit] = useState<boolean>(false);
  const [additionalFiles, setAdditionalFiles] = useState<any[]>();
  const [image, setImage] = useState<File>();
  const [state, setState] = useState<NewsItem>({
    title: "",
    intro: "",
    content: "",
    date: "",
    hideDate: false,
    isVideoHeadLine: false,
    isComment: false,
    isPaidContent: false,
    isTransporterGuide: false,
    isPremium: false,
    isArval: false,
    videoEmbed: null,
    script: "",
    isActive: true,
    redirectToUrl: "",
    subtitle: "",
    author: null,
    brand: null,
    model: null,
    seoTitle: "",
    seoTags: "",
    seoDescription: "",
    profilePicture: null,
    link1: "",
    link2: "",
    link3: "",
    fileData: [
      {
        id: null,
        name: "",
        path: "",
        legend: "",
        credit: "",
        index: null,
      },
    ],
    additionalFiles: [],
  });
  const [files, setFiles] = useState<any[]>([]);
  const submitHandler = (event: any) => {
    setDisabledSubmit(true);
    console.log(files?.map((item: any) => item));

    const formData = new FormData();
    if (files) {
      for (let i = 0; i < files?.length; i++) {
        formData.append("file[]", files[i]);
      }
    }
    image && formData.append("mainImage", image);
    formData.append("body", JSON.stringify(state));
    AdminTestsService.update(formData, +id!)
      .then((response) => {
        SuccessToast(t(`test.successfully_updated`));
        navigate("/admin/tests");
      })
      .catch((error) => ErrorToast(error))
      .finally(() => setDisabledSubmit(false));
  };

  return (
    <div className="col-12" id="scrollable-form">
      <Form
        onSubmit={(e) => {
          e.preventDefault();
          submitHandler(e);
        }}
      >
        <CreateForm
          setImage={setImage}
          disabledSubmit={disabledSubmit}
          submitHandler={submitHandler}
          state={state}
          setState={setState}
          files={files}
          setFiles={setFiles}
          additionalFiles={additionalFiles}
          setAdditionalFiles={setAdditionalFiles}
        />
      </Form>
    </div>
  );
};
